export default {
  methods: {
    getRelationalValue(value, relationalValues) {
      if (Array.isArray(relationalValues)) {
        return relationalValues.find(rV => rV.value == value)?.text;
      }
      return relationalValues[value];
    },
    valueFormatter(params) {
      const { value, colDef } = params;
      if (value === null || value === undefined) {
        return 'NULL';
      }
      const { name: dataTypeName } = params.colDef.dataType;
      if (dataTypeName === 'datetime') {
        return this.$dayjs(value).format('L, LT');
      } else if (dataTypeName === 'date') {
        return this.$dayjs(value).format('L');
      } else if (dataTypeName === 'time') {
        return this.$dayjs(value, 'HH:mm:ss').format('LTS');
      } else if (dataTypeName === 'boolean') {
        return value
          ? colDef.dataType.true || this.$i18n.t('inputs.true')
          : colDef.dataType.false || this.$i18n.t('inputs.false');
      }
      return value;
    },
    valueGetter(params) {
      if (!this.attributesMetadata) {
        return;
      }
      const { field, isRelational, relationalValues } = params.colDef;
      const value = params.data?.[field];
      const computedValue = isRelational ? this.getRelationalValue(value, relationalValues) : value;
      return computedValue;
    },
    getColorSelectCell() {
      const self = this;
      function ColorSelectCell() {}
      ColorSelectCell.prototype.init = function(params) {
        const { value, valueFormatted } = params;
        const { dictValues, dictColors } = params.colDef;

        const index = dictValues.indexOf(value);
        const color = dictColors[index];
        const textColor = self.$_isHexColorLight(color || '#ffffff') ? '#202124' : 'white';

        this.eGui = document.createElement('div');
        this.eGui.style.cssText = `background-color: ${color || 'rgba(0,0,0,0)'};
          display: initial; padding: 3px 8px; border-radius: 4px; color: ${textColor}; font-weight: 500`;
        // valueFormatter returns formatted value under valueFormatted key ('value' key value remains unformatted)
        this.eGui.innerHTML = valueFormatted;
      };

      ColorSelectCell.prototype.getGui = function() {
        return this.eGui;
      };

      return ColorSelectCell;
    },
    getStatusCell() {
      const self = this;
      function StatusCell() {}

      StatusCell.prototype.init = function(params) {
        const statusItem = self.statusesItems.find(status => status.value === params.valueFormatted);
        this.eGui = document.createElement('div');
        this.eGui.style.cssText = `background-color: ${statusItem ? statusItem.color : 'white'};
          display: initial; padding: 3px 8px; border-radius: 4px; color: white; font-weight: 500`;
        // valueFormatter returns formatted value under valueFormatted key ('value' key value remains unformatted)
        this.eGui.innerHTML = params.valueFormatted;
      };

      StatusCell.prototype.getGui = function() {
        return this.eGui;
      };

      return StatusCell;
    },
    getCellRendererHandler(params) {
      const { field, dictColors, dictValues } = params.colDef;
      // if more renderers would appear in futrue create dict instead of multiplying if statements
      if (this.isCustomLayer && (field === 'status' || field === 'ZgloszenieStatus')) {
        return {
          component: 'StatusCell',
        };
      } else if (
        dictColors &&
        dictValues &&
        dictColors.length === dictValues.length &&
        dictColors.every(color => Boolean(color))
      ) {
        return {
          component: 'ColorSelectCell',
        };
      }
      return null;
    },
  },
};
